// ============================================================
// BOLD BRASILEIRO — Antes / Depois slider
// Drag horizontal pra revelar antes/depois com clip-path
// ============================================================

(function () {
    'use strict';

    const sliders = document.querySelectorAll('[data-ba-slider]');
    if (!sliders.length) return;

    sliders.forEach(slider => {
        const after  = slider.querySelector('.box-work__after');
        const handle = slider.querySelector('.box-work__handle');
        if (!after || !handle) return;

        let isDragging = false;

        const setPosition = (clientX) => {
            const rect = slider.getBoundingClientRect();
            let x = clientX - rect.left;
            x = Math.max(0, Math.min(x, rect.width));
            const percent = (x / rect.width) * 100;

            after.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
            handle.style.left = `${percent}%`;
        };

        // Mouse
        slider.addEventListener('mousedown', (e) => {
            isDragging = true;
            setPosition(e.clientX);
            e.preventDefault();
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            setPosition(e.clientX);
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
        });

        // Touch
        slider.addEventListener('touchstart', (e) => {
            isDragging = true;
            setPosition(e.touches[0].clientX);
        }, { passive: true });

        slider.addEventListener('touchmove', (e) => {
            if (!isDragging) return;
            setPosition(e.touches[0].clientX);
        }, { passive: true });

        slider.addEventListener('touchend', () => {
            isDragging = false;
        });

        // Click pra mover instantaneamente (sem drag)
        slider.addEventListener('click', (e) => {
            setPosition(e.clientX);
        });
    });
})();
